import * as React from "react";
import { Step, Question } from ".";

// The same questions as in the original Step1Page
const questions: Question[] = [
    {
        question: "Le service de tutorat va au-delà de l’aide aux devoirs. Sur quoi repose principalement son efficacité auprès des élèves-athlètes ?",
        answers: ["Sur la capacité du tuteur à corriger les devoirs de manière rigoureuse.",
            "Sur la création d’un environnement de travail silencieux et encadré pour faire les devoirs.",
            "Sur une approche personnalisée visant à outiller l’élève-athlète dans ses stratégies d’apprentissage, son organisation et sa prise d’autonomie.",
            "Sur le fait que les tuteurs possèdent une excellente moyenne scolaire et peuvent répondre à toutes les questions rapidement."],
        correctAnswer: 2,
        explanation: "L’efficacité du tutorat ne repose pas uniquement sur la transmission de connaissances ou sur la supervision des devoirs, mais plutôt sur une approche pédagogique individualisée. Cette approche vise à aider l’élève-athlète à développer ses propres stratégies d’apprentissage, à mieux s’organiser dans ses tâches scolaires, et à gagner en autonomie. C’est cette posture de développement qui permet à long terme une amélioration durable de ses compétences scolaires et de sa confiance."
    },
    {
        question: "VRAI ou FAUX : Nous accompagnons les élèves-athlètes issus de l’immigration de la même façon que nous accompagnons les élèves-athlètes nés au Québec ? ",
        answers: ["VRAI", "FAUX"],
        correctAnswer: 1,
        explanation: "Faux :Nous devons prendre conscience de nos biais cognitif face à la culture de l’autre, se permettre de la découvrir et adapter notre accompagnement en prenant le temps de vérifier la compréhension plus fréquemment, en encourageant les questionnements et en faisant preuve d’empathie."
    }
];

export function Step3Page() {
    return (
        <Step
            stepNumber="3"
            title="Troisième capsule"
            videoUrl={`${process.env.PUBLIC_URL}/assets/formation-videos/video3.mp4`}
            redirectURL="/formation/4"
            questions={questions}
        />
    );
} 